import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/styles/index.scss'
import 'element-ui/lib/theme-chalk/display.css';
import Element from 'element-ui'
import store from './store/index'
import {initTheme} from '@/utils/theme'
import './utils/permission'
import 'element-ui/lib/theme-chalk/index.css'
import "@/utils/china"
import BaiduMap from 'vue-baidu-map'

Vue.prototype.refresh = new Vue();
Vue.use(Element);
Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: 'p9PZs4HFKXuvZ57hWdHDWMIksvMGPoFL'
})

initTheme()
store.dispatch('theme/initTheme')

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
